import React from "react";

import TosPreview from "../TosPreview/TosPreview";
import { RegisterUser } from "../../../apis/UserSessionAPI";
import TextLineInput from "../../../ui-components/TextLineInput";
import EmailInput from "../../../ui-components/EmailInput";
import Label from "../../../ui-components/Label";
import PasswordInput from "../../../ui-components/PasswordInput";
import SubmitButton from "../../../ui-components/SubmitButton";
import CheckBoxInput from "../../../ui-components/CheckBoxInput";

import { registerSignupToFacebook } from "../../../apis/Analytics/registerOrderToFacebook";
import { sendConsentIub } from "../../../utils/consentManager";
import Col from "react-bootstrap/lib/Col";
import Row from "react-bootstrap/lib/Row";
import RecaptchaInfo from "../RecaptchaInfo";


async function registerConsent(user) {
  await sendConsentIub(user);
}

export default class SignUpUserForm extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      first_name: "",
      last_name: "",
      email: props.prefilledEmail || "",
      email_confirmation: props.prefilledEmail || "",
      password: "",
      password_confirmation: "",
      terms_of_service: false,
      marketing: false,
      profiling: false,
      errors: {},
      inviter_referral_code: props.inviter_referral_code || "",
      showConsentModal: false,
      isLoading: false
    };

    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleInputChange(event) {
    const target = event.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const name = target.name;

    this.setState({
      [name]: value
    });
  }

  handleSubmit(event) {
    event.preventDefault();

    if (!!this.state.isLoading) {
      return
    }

    const userData = {
      first_name: this.state.first_name,
      last_name: this.state.last_name,
      email: this.state.email,
      email_confirmation: this.state.email_confirmation,
      password: this.state.password,
      password_confirmation: this.state.password_confirmation,
      terms_of_service: this.state.terms_of_service ? "1" : "0",
      consents: {
        customer_terms: this.state.terms_of_service ? "1" : "0",
        customer_marketing: this.state.marketing ? "1" : "0",
        customer_profiling: this.state.profiling ? "1" : "0"
      },
      inviter_referral_code: this.state.inviter_referral_code
    };

    this.setState({ isLoading: true} )

    grecaptcha.enterprise.ready(async () => {
      const recaptchaToken = await grecaptcha.enterprise.execute(process.env.GOOGLE_RECAPTCHA_KEY_ID, { action: 'SIGNUP' });

      RegisterUser(userData, recaptchaToken)
        .then(response => {
          if (this.props.onLogin) {
            registerSignupToFacebook();
            registerConsent(response.user_session.user);
            this.props.onLogin(response);
          }

          this.setState({ isLoading: false })
        })
        .catch(error => {
          if (error.status === 429) {
            alert(I18n.t("pages.user_session.user.errors.max_reached"))
          }

          const errors = error.response.body?.errors;

          this.setState({
            errors: errors || [],
            isLoading: false
          });
        });
    })
  }

  render() {
    return (
      <form onSubmit={this.handleSubmit}>
        <Row>
          <Col sm={6}>
            <Label required={true}>{I18n.t("pages.user_session.user.first_name")}</Label>
            <TextLineInput
              name="first_name"
              value={this.state.first_name}
              onChange={this.handleInputChange}
              errors={this.state.errors.first_name}
            />
          </Col>
          <Col sm={6}>
            <Label required={true}>{I18n.t("pages.user_session.user.last_name")}</Label>
            <TextLineInput
              name="last_name"
              value={this.state.last_name}
              onChange={this.handleInputChange}
              errors={this.state.errors.last_name}
            />
          </Col>
        </Row>

        <Row>
          <Col sm={6}>
            <Label required={true}>{I18n.t("pages.user_session.user.email")}</Label>
            <EmailInput
              name="email"
              value={this.state.email}
              disabled={!!this.props.prefilledEmail}
              onChange={this.handleInputChange}
              errors={this.state.errors.email}
            />
          </Col>
          <Col sm={6}>
            <Label required={true}>{I18n.t("pages.user_session.user.email_confirmation")}</Label>
            <EmailInput
              name="email_confirmation"
              value={this.state.email_confirmation}
              disabled={!!this.props.prefilledEmail}
              onChange={this.handleInputChange}
              errors={this.state.errors.email_confirmation}
            />
          </Col>
        </Row>

        <Row>
          <Col sm={6}>
            <Label required={true}>{I18n.t("pages.user_session.user.password")}</Label>
            <PasswordInput
              name="password"
              value={this.state.password}
              onChange={this.handleInputChange}
              errors={this.state.errors.password}
            />
          </Col>
          <Col sm={6}>
            <Label required={true}>{I18n.t("pages.user_session.user.password_confirmation")}</Label>
            <PasswordInput
              name="password_confirmation"
              value={this.state.password_confirmation}
              onChange={this.handleInputChange}
              errors={this.state.errors.password_confirmation}
            />
          </Col>
        </Row>
        <Row>
          <Col sm={6} xs={12}>
            <Label>{I18n.t("pages.user_session.user.referral_code")}</Label>
            <TextLineInput
              name="inviter_referral_code"
              value={this.state.inviter_referral_code}
              onChange={this.handleInputChange}
              errors={this.state.errors.inviter_referral_code}
            />
          </Col>
        </Row>

        <Row>
          <Col sm={12}>
            <TosPreview text={I18n.t("tos_html")} />
          </Col>
        </Row>

        <Row className={"mb-4"}>
          <Col sm={12} className="mt-4">
            <TosPreview text={I18n.t("pages.privacy.body_html")} />
          </Col>
        </Row>

        <Row>
          <Col sm={12}>
            <CheckBoxInput
              name="terms_of_service"
              checked={this.state.terms_of_service}
              onChange={this.handleInputChange}
              label={I18n.t("pages.user_session.user.terms_of_service")}
              errors={this.state.errors.terms_of_service}
            />
          </Col>
        </Row>

        <Row>
          <Col sm={12}>
            <CheckBoxInput
              name="marketing"
              checked={this.state.marketing}
              onChange={this.handleInputChange}
              label={I18n.t("pages.user_session.user.marketing")}
              errors={this.state.errors.marketing}
            />
          </Col>
        </Row>

        <Row>
          <Col sm={12}>
            <CheckBoxInput
              name="profiling"
              checked={this.state.profiling}
              onChange={this.handleInputChange}
              label={I18n.t("pages.user_session.user.profiling")}
              errors={this.state.errors.profiling}
            />
          </Col>
        </Row>

        <Row className={"mt-4"}>
          <Col sm={6} smPush={3}>
            <SubmitButton
              ariaDisabled={this.state.isLoading}
              value={this.state.isLoading ? I18n.t("wait") + "..." : I18n.t("continue")}
              className="sign-user-page-btn"
            />
          </Col>
        </Row>

        <Row>
          <Col sm={12} smPush={0}>
            <RecaptchaInfo/>
          </Col>
        </Row>
      </form>
    );
  }
}
